export enum UserDeclarationType {
  Private = 'private',
  Public = 'public',
}

export enum SelfDeclarationAction {
  Accept = 'accept',
  Reject = 'reject',
}

export interface ISelfDeclarationModalContext {
  isModalOpen: boolean,
  dataroomId: number | null,
  dataroomName: string | null,
  isFetching: boolean,
  openModal: (dataroomId: number, dataroomName: string) => void,
  closeModal: () => void,
  onAccept: (() => void) | null,
  setOnAccept: (callback: () => void) => void,
  declareUserAction: (
    action: SelfDeclarationAction,
    visibilityType: UserDeclarationType,
    submitDeclaration: (
      dataroomId: number,
      action: SelfDeclarationAction,
      visibilityType: UserDeclarationType,
    ) => Promise<void>,
  ) => Promise<void>,
}

// DI key of the self declaration context value. Kept out of the 'use client' context module,
// so that code reachable from the server (JSON-RPC interceptors) can reference it without
// dotting into a client module — see DataroomTenantContextSymbol in @dataroom/tenant/types.
export const SelfDeclarationModalContextSymbol = Symbol('SelfDeclarationModalContext');

// Server only: bound in `fetchDataroomData`, set by the error handler, read back there.
export const SelfDeclarationSeedSymbol = Symbol('SelfDeclarationSeed');

export interface ISelfDeclarationSeed {
  dataroomId: number,
}

// Returned instead of thrown: Server Action errors reach the client masked in production.
export interface ISelfDeclarationActionResult {
  error: string | null,
}
